import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import Select from 'react-select';
import { Field } from '../../../ui/Field';
import UpdatePage from '../../../composents/UpdatePage';

const title = 'Groups';
const headers = {
	icon: 'feather icon-edit',
	title: title,
	description: 'update of group',
	breadcrumbs: [
		{
			title: title,
			link: '/administrators/groups',
		},
	],
};

export default function EditGroup() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({}),
		[clients, setClients] = useState([]),
		[data, setData] = useState(),
		{ id } = useParams(),
		[group, setGroup] = useState(),
		[fail, setFail] = useState(false),
		[loading, setLoading] = useState(true),
		[allTypeData, setAllTypeData] = useState([]),
		groups = [
			{
				value: 'countries',
				label: 'Countries',
			},
			{
				value: 'cities',
				label: 'Cities',
			},
			{
				value: 'entities',
				label: 'HD-entity',
			},
			{
				value: 'clients',
				label: 'Clients',
			},
			{
				value: 'consumers',
				label: 'Consumers',
			},
			{
				value: 'zones',
				label: 'Zones',
			},
			{
				value: 'meters',
				label: 'Meters',
			},
			{
				value: 'restrictions',
				label: 'Restrictions',
			},
			{
				value: 'subscriptions',
				label: 'Subscription',
			},

			{
				value: 'cards',
				label: 'Water cards',
			},
			{
				value: 'consumptions',
				label: 'Consumptions',
			},
			{
				value: 'recharges',
				label: 'Top Up',
			},
			// {
			// 	value: 'general stats',
			// 	label: 'General stats',
			// },
			{
				value: 'permissions',
				label: 'Permissions',
			},
			{
				value: 'groups',
				label: 'Groups',
			},
			{
				value: 'users',
				label: 'Users',
			},
			{
				value: 'agents',
				label: 'Agents',
			},
		];

	async function onGet() {
		setLoading(true);
		let gro = await resources.group
			.readOne(id)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});

		if (gro.status === 200) {
			setData(gro.data);
		} else if (gro.status === 403) {
			setFail(true);
		}

		let cli = await resources.permission
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (cli.status === 200) {
			let a = [];
			let b = [];
			cli.data.docs.forEach((el) => {
				gro?.data?.permission?.forEach((element) => {
					if (element === el.id) {
						b.push({
							value: el.id,
							label: el.title + ' ' + el.group,
							group: el.group,
						});
					}
				});
				a.push({
					value: el.id,
					label: el.title + ' ' + el.group,
					group: el.group,
				});
			});
			setClients(a);
			setAllTypeData(b);
		}

		setLoading(false);
	}

	useEffect(() => {
		onGet();
	}, []);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		if (allTypeData) object.permission = allTypeData.map((e) => e.value);
		if (data?.client?.id) object.client = data?.client?.id;
		setLoader(true);
		setErrors({});
		let res = await resources.group
			.update(id, object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});

		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/administrators/groups');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}

		setLoader(false);
	}

	const filterPermission = () => {
		if (group) {
			return clients.filter((g) => g.group === group.value);
		}

		return clients;
	};

	return (
		<UpdatePage
			show_error={errors['not_autorized']}
			loading={loading}
			fail={fail}
			headers={headers}
		>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<div className="mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Client
									</label>
									<input
										readOnly
										type="text"
										className="form-control"
										id="exampleInputEmail1"
										defaultValue={data?.client?.name}
									/>
								</div>

								<Field
									name="title"
									className="mb-3"
									error={errors['title']}
									defaultValue={data?.title}
									required
								>
									Title
								</Field>

								<Field
									name="role"
									className="mb-3"
									error={errors['role']}
									defaultValue={data?.role}
									required
								>
									Type
								</Field>

								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Group of permission{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={setGroup}
										options={groups}
										isSearchable
										isClearable
									/>
								</div>

								<div className="mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Permissions{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										isMulti
										onChange={setAllTypeData}
										value={allTypeData}
										options={filterPermission()}
									/>
								</div>

								<Field
									name="description"
									type="textarea"
									defaultValue={data?.description}
									error={errors['description']}
									className="mb-3"
								>
									Note
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</UpdatePage>
	);
}
